/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


export default class
{
  constructor ()
  {
    this.collection = new Map();
  }


  push (influence)
  {
    const user = influence.getUser();

    if (!this.collection.has(user))
    {
      this.collection.set(user, []);
    }

    this.collection.get(user).push(influence);
  }


  getInfluence (user)
  {
    if (!this.collection.has(user))
    {
      return 0;
    }

    let value = 0;

    for (const influence of this.collection.get(user))
    {
      value += influence.getValue();
    }

    return value;
  }


  eachInfluence (callback)
  {
    for (const [user, collection] of this.collection)
    {
      for (const influence of collection)
      {
        callback(influence);
      }
    }
  }


  eachInfluenceUser (callback)
  {
    for (const [user, _] of this.collection)
    {
      callback(user);
    }
  }


  getUsers ()
  {
    return this.collection.keys();
  }


}
